<script setup lang="ts">
/** Рукописный штрих из брендбука, перекрашивается CSS-маской. Порт Doodle.jsx из дизайн-системы. */
export type DoodleName = 'sparkle' | 'brush-star' | 'wave-line' | 'heart-left' | 'heart-right' | 'arrow-body' | 'arrow-head';
const props = withDefaults(defineProps<{ name?: DoodleName; width?: number; color?: string; rotate?: number }>(), {
  name: 'sparkle', width: 120, color: 'var(--doodle-sparkle)', rotate: 0,
});
const RATIO: Record<DoodleName, [number, number]> = {
  'sparkle': [382.377, 627.257],
  'brush-star': [1089, 1129],
  'wave-line': [2090.824, 1657.775],
  'heart-left': [792.198, 930.006],
  'heart-right': [496, 1089],
  'arrow-body': [1684.434, 1026.533],
  'arrow-head': [280, 192],
};
const files: Record<DoodleName, string> = {
  'sparkle': '/ff/sparkle.svg',
  'brush-star': '/ff/brush-star.svg',
  'wave-line': '/ff/wave-line.svg',
  'heart-left': '/ff/heart-left.svg',
  'heart-right': '/ff/heart-right.svg',
  'arrow-body': '/ff/arrow-body.svg',
  'arrow-head': '/ff/arrow-head.svg',
};
const [w, h] = RATIO[props.name];
const url = `url(${files[props.name]})`;
</script>
<template><span aria-hidden="true" :style="{ display: 'inline-block', width: `${props.width}px`, height: `${props.width * h / w}px`, background: props.color, '-webkit-mask': `${url} center/contain no-repeat`, mask: `${url} center/contain no-repeat`, transform: props.rotate ? `rotate(${props.rotate}deg)` : undefined }" /></template>
